module.exports = __webpack_public_path__ + "img/img20.370612d4.png";